import { render, staticRenderFns } from "./PromocaoCard.vue?vue&type=template&id=d9dd2260&"
import script from "./PromocaoCard.vue?vue&type=script&lang=js&"
export * from "./PromocaoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports